export default class MockSoundManager {
	constructor() {
		this._timeout = 5000;
		this.audioCtx = {
			state: 'running',
			addEventListener() {},
			removeEventListener() {},
			createBufferSource() {
				const listeners = {};
				return {
					addEventListener(e, cb) { listeners[e] = cb; },
				removeEventListener(e) { delete listeners[e]; },
					buffer: null,
					playbackRate: { value: 1 },
					start() { setTimeout(() => listeners.ended?.(), 1000 + Math.random() * 4000); },
					stop() {},
					connect() {},
					disconnect() {},
				};
			},
			decodeAudioData() {
				return new Promise((resolve, reject) => {
					setTimeout(() => {
						if(Math.random() < 0.01) reject(new Error('mock load error'));
						else resolve(null);
					}, 500 + Math.random() * 1500);
				});
			},
		};
	}

	get timeout() { return this._timeout; }
	set timeout(_v) {}

	addEventListener() {}
	removeEventListener() {}
	setVolume() {}
	computeNormalizeGain() { return 1; }
}
